// src/utils/shareCard.js
// 1080×1920 IG-story share card, drawn on a canvas and downloaded as PNG —
// hosts posting achievements is the program's free-marketing loop. Used by
// the CelebrationOverlay (badges/level-ups) and the WheelSpinModal.

export function downloadShareCard({ brandName, hostFirstName, headline, subline }) {
  const canvas = document.createElement('canvas');
  canvas.width = 1080;
  canvas.height = 1920;
  const ctx = canvas.getContext('2d');
  const grad = ctx.createLinearGradient(0, 0, 1080, 1920);
  grad.addColorStop(0, '#1a1145');
  grad.addColorStop(0.55, '#4527a0');
  grad.addColorStop(1, '#7b1fa2');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, 1080, 1920);

  ctx.textAlign = 'center';
  ctx.fillStyle = 'rgba(255,255,255,0.85)';
  ctx.font = '600 52px Inter, Arial, sans-serif';
  ctx.fillText(String(brandName || '').toUpperCase(), 540, 340);

  ctx.font = '120px serif';
  ctx.fillText('🏆', 540, 760);

  ctx.fillStyle = '#ffffff';
  ctx.font = '800 88px Inter, Arial, sans-serif';
  const words = String(headline || '').split(' ');
  let line = '';
  let y = 940;
  for (const w of words) {
    if ((line + ' ' + w).trim().length > 18) {
      ctx.fillText(line.trim(), 540, y);
      line = w;
      y += 108;
    } else {
      line = `${line} ${w}`;
    }
  }
  if (line.trim()) ctx.fillText(line.trim(), 540, y);

  ctx.fillStyle = '#ffd54f';
  ctx.font = '700 56px Inter, Arial, sans-serif';
  ctx.fillText(String(subline || ''), 540, y + 160);

  ctx.fillStyle = 'rgba(255,255,255,0.75)';
  ctx.font = '500 44px Inter, Arial, sans-serif';
  ctx.fillText(hostFirstName ? `${hostFirstName} · ${brandName}` : String(brandName || ''), 540, 1700);

  const link = document.createElement('a');
  link.download = 'achievement-story.png';
  link.href = canvas.toDataURL('image/png');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
